var $d2a4cd1ccd3b9660$exports = {};
$d2a4cd1ccd3b9660$exports = {
  "pending": `ootel`
};
export { $d2a4cd1ccd3b9660$exports as default };